import Conditional from 'decorators/conditional';
import Desktop from './index.desktop';
import Mobile from './index.mobile';

export default Conditional({
  mobile: Mobile,
  tablet: Mobile,
  desktop: Desktop,
});
